/**
 * `rangeDays` reaches the screens from a query parameter, so it can be any
 * number a person types. The `markets` router accepts 1..90 and rejects the
 * rest, so clamp here and keep the card readable instead of showing an error.
 */
export const marketsMinRangeDays = 1;
export const marketsMaxRangeDays = 90;

export function clampMarketsRangeDays(rangeDays: number): number {
  if (!Number.isFinite(rangeDays)) {
    return marketsMinRangeDays;
  }
  return Math.min(Math.max(Math.round(rangeDays), marketsMinRangeDays), marketsMaxRangeDays);
}

/**
 * `share` and `delta` are percentages in the 0..100 range; `Intl` works in
 * fractions. One place to divide, so a card never shows 6250%.
 */
export function asPercentFraction(percent: number): number {
  return percent / 100;
}
